import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { Wordmark } from '@/components/brand/wordmark';

/** Whole-screen notice for blocking situations (suspended company, disabled account, 404). */
export function FullPageMessage({
  icon: Icon,
  tone = 'neutral',
  title,
  children,
  actions,
}: {
  icon: LucideIcon;
  tone?: 'neutral' | 'danger';
  title: string;
  children: ReactNode;
  actions?: ReactNode;
}) {
  const iconTone =
    tone === 'danger'
      ? 'bg-red-50 text-red-600 dark:bg-red-950/50 dark:text-red-400'
      : 'bg-brand-50 text-brand-600 dark:bg-brand-950/60 dark:text-brand-300';
  return (
    <main className="grid min-h-dvh place-items-center bg-background px-4 py-12">
      <div className="w-full max-w-md text-center">
        <Wordmark className="mb-10 justify-center" />
        <span className={`mx-auto mb-5 grid size-14 place-items-center rounded-2xl ${iconTone}`}>
          <Icon aria-hidden="true" className="size-7" />
        </span>
        <h1 className="text-xl font-semibold tracking-tight">{title}</h1>
        <div className="mt-2 text-sm leading-relaxed text-muted-foreground">{children}</div>
        {actions && <div className="mt-8 flex flex-wrap justify-center gap-3">{actions}</div>}
      </div>
    </main>
  );
}
